module.exports = __webpack_public_path__ + "img/HQ-PA050W2T2RL-T.4dbfffca.jpg";